import React from 'react';
import ContentMasteryTestErrorRateSummaryContainer from './mastery-test/ContentMasteryTestErrorRateSummaryContainer';
import ContentMasteryTestFailureAttemptRateSummaryContainer from './mastery-test/ContentMasteryTestFailureAttemptRateSummaryContainer';
import ContentMasteryTestRepeatRateSummaryContainer from './mastery-test/ContentMasteryTestRepeatRateSummaryContainer';
import ContentMasteryTestSpeechRateSummaryContainer from './mastery-test/ContentMasteryTestSpeechRateSummaryContainer';

const ContentMasteryTestDetailSummary = () => (
  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    <ContentMasteryTestFailureAttemptRateSummaryContainer />
    <ContentMasteryTestRepeatRateSummaryContainer />
    <ContentMasteryTestSpeechRateSummaryContainer />
    <ContentMasteryTestErrorRateSummaryContainer />
  </div>
);

export default ContentMasteryTestDetailSummary;
